import Repository from "@/repositories/RepositoryFactory";

const AdminUsersRepository = Repository.get("AdminUsersRepository");

class AdminUsersService {
  GetAdmins = async () => {
    const response = await AdminUsersRepository.GetAdmins();
    return response.data;
  };

  CreateAdmin = async (data) => {
    const response = await AdminUsersRepository.CreateAdmin(data);
    return response.data;
  };

  DeleteAdmin = async (id) => {
    const response = await AdminUsersRepository.DeleteAdmin(id);
    return response.data;
  };
}

export default new AdminUsersService();
